import { useState } from 'react';
import { Message } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { AppButton } from '../../../shared/components/buttons/AppButton';
import ContactSellerModal from './ContactSellerModal';

interface SendMessageButtonProps {
  offerId: string;
  sellerName?: string;
  phoneNumber?: string | null;
}

export default function SendMessageButton({
  offerId,
  sellerName,
  phoneNumber,
}: Readonly<SendMessageButtonProps>) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <AppButton
        size="small"
        variant="outlined"
        fullWidth
        startIcon={<Message />}
        onClick={handleOpen}
        sx={{ mb: 2 }}
      >
        {t('offerDetail.sendMessage')}
      </AppButton>
      <ContactSellerModal
        open={isOpen}
        onClose={handleClose}
        offerId={offerId}
        sellerName={sellerName}
        phoneNumber={phoneNumber}
      />
    </>
  );
}
